export default "__VITE_ASSET__DjeTDdfE__"